import _styled from "styled-components";
export function FooterCopyright() {
  return <_StyledP>
      © {new Date().getFullYear()}, Ouster Inc. All rights reserved.
    </_StyledP>;
}
var _StyledP = /*#__PURE__*/_styled("p").withConfig({
  displayName: "footer-copyright___StyledP",
  componentId: "sc-xuroc1-0"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(92 92 92 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});